import React from 'react';
import { Link } from 'react-router-dom';
import { getAllColumns } from '../../utils/constants';

const SearchBar = ({
  searchField,
  search,
  handleFieldChange,
  handleSearch,
  selectedColumns,
  hasAccess,
  openAdvancedSearch
}) => {
  const searchableColumns = getAllColumns().filter(column =>
    selectedColumns.includes(column.key)
  );

  return (
    <div className="search-bar-container">
      <div className="search-bar">
        {/* Search Field Selector */}
        <select
          className="select-dropdown"
          onChange={handleFieldChange}
          value={searchField}
        >
          {searchableColumns.map(column => (
            <option key={column.key} value={column.key}>
              {column.label}
            </option>
          ))}
        </select>

        {/* Text Input for Search */}
        <input
          type="text"
          placeholder={`Search by ${searchableColumns.find(col => col.key === searchField)?.label || 'Name'}...`}
          value={search}
          onChange={handleSearch}
          className="searchsd-input"
        />

        {/* Advanced Search Button */}
        <button
          className="advanced-search-btn"
          onClick={openAdvancedSearch}
          type="button"
        >
          Advanced Search
        </button>

        {/* New Admission Button */}
        {hasAccess && (
          <Link to="/admission-form" className="new-admission-btn">
            New Admission
          </Link>
        )}
      </div>
    </div>
  );
};

export default SearchBar;